module.exports = __webpack_public_path__ + "97def7cfb2eca6ddaa6bf923338104f4.png";